import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconScreenRotationOutline } from '@saucelabs/ds-icons';

import { TOOLBAR_TRACKING_NAMES, trackEvent } from '../../../tracking';
import { rotateMobileDevice } from '../../../actions';
import selectors from '../selectors';
import GenericButton from './GenericButton';

const RotateDeviceButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    deviceToolsDisabled,
    deviceType,
    testType,
  } = useSelector(selectors.toolbarButtonSelector);

  const rotateDevice = () => {
    void dispatch(rotateMobileDevice());
    trackEvent(TOOLBAR_TRACKING_NAMES.ROTATE_DEVICE, { deviceType, testType });
  };

  return (
    <GenericButton
      disabled={deviceToolsDisabled}
      icon={IconScreenRotationOutline}
      label="Rotate Device"
      onPress={rotateDevice}
      role={role}
    />
  );
};

RotateDeviceButton.displayName = 'RotateDeviceButton';

export default RotateDeviceButton;
